import {
  LocationMatchesRoomsForMassBookingState,
  LocationMatchesRoomsForMassBookingActionTypes,
  LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST,
  LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS,
  LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE
} from "store/reducers/room/location-matches-rooms-for-mass-booking/types";

const defaultState: LocationMatchesRoomsForMassBookingState = {
  isLoading: false,
  errorMessage: ""
};

export default function locationMatchesRoomsForMassBooking(state = defaultState, action: LocationMatchesRoomsForMassBookingActionTypes): LocationMatchesRoomsForMassBookingState {
  switch (action.type) {
    case LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};